import { Divider, Typography } from "@/components/atoms";

interface ProfileDetailProps extends React.PropsWithChildren {
  label: string | JSX.Element;
  description?: string;
  icon?: JSX.Element;
}

export const ProfileDetail = ({ label, description = "", icon, children, ...props }: ProfileDetailProps) => {
  return (
    <div className="flex flex-col">
      <div className="grid w-full grid-cols-4 gap-x-8" {...props}>
        <div className="col-span-4 flex flex-col gap-y-1.5 sm:col-span-1">
          <div className="flex flex-row gap-x-3">
            {typeof label === "string" ? <Typography variant="paragraph">{label}</Typography> : <label.type {...label.props} />}
            {icon}
          </div>
          {description && (
            <Typography variant="small" className="text-neutral-dark-gray">
              {description}
            </Typography>
          )}
        </div>
        <div className="col-span-4 flex flex-col sm:col-span-3">
          <div className="flex-1">{children}</div>
        </div>
      </div>
      <div className="mt-6 grid w-full grid-cols-4">
        <div className="col-span-4 flex flex-col sm:col-span-3 sm:col-end-5">
          <Divider className="w-full self-end" />
        </div>
      </div>
    </div>
  );
};
